import { render, staticRenderFns } from "./UserN_TransactionSetting.vue?vue&type=template&id=eed490aa"
import script from "./UserN_TransactionSetting.vue?vue&type=script&lang=js"
export * from "./UserN_TransactionSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports